import { FieldSet } from "../common-styling";
import IntegrationsTableView from "./integration-view/integrations-table-view";
import { useTranslation } from "react-i18next";

const Leadpool = ({ leadpoolIntegrations = [] }) => {
  const { t } = useTranslation();
  const readonlyIntegrations = leadpoolIntegrations.map((integration) => ({
    ...integration,
    activeLabel: integration.active ? t("common.enabled") : t("common.inactive")
  }));
  const generateHeaderItem = (name, colWidth = null) => {
    return { name, colWidth, style: "pb-1" };
  };

  return (
    <div className="px-3">
      <FieldSet>
        <IntegrationsTableView
          headers={[
            generateHeaderItem("Status"),
            generateHeaderItem("Webhook URL"),
            generateHeaderItem("Source"),
            generateHeaderItem(t("funnelIntegration.sendDataHeading")),
            generateHeaderItem(t("common.description"))
          ]}
          integrations={readonlyIntegrations}
          propertiesToRender={[
            "activeLabel",
            "sourceData.id",
            "sourceData.meta.leadpoolSource",
            "sourceData.meta.sendData",
            "description"
          ]}
          readOnly
        />
      </FieldSet>
    </div>
  );
};

export default Leadpool;
